// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css_chunk." + chunkId + "." + {"6004":"3927096d4e925fd6aaa8","6524":"33d314052d06c1e46600","7666":"e55ce71d307b99bdfdee"}[chunkId] + ".min.css";
};